import React from 'react';
import { useParams } from 'react-router-dom';
import { PaddedPageWrapper } from '../../components/atoms';
import { useGlobalContext } from '../../containers/App/context';
import { FlowTest } from '../../components/FlowTest';

const FlowTestPage = () => {
  const { id } = useParams();
  const { getMeData, getMeRefetch } = useGlobalContext();
  const onboardingComplete = getMeData?.getOnboardingStatus === 'COMPLETE';

  if (!onboardingComplete) {
    getMeRefetch();
    return null;
  }

  if (!id) {
    return 'Missing ID';
  }

  return (
    <PaddedPageWrapper padding="0">
      <FlowTest flowId={id} />
    </PaddedPageWrapper>
  );
};

export default FlowTestPage;
